const CACHE_NAME = 'audioCache';
export class PlayerCache {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    static ENABLED = process.env['NEXT_PUBLIC_RELEASE_STAGE'] !== 'local';

    static loadUrls(urls: string[]) {
        if (!PlayerCache.ENABLED) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        window && window.caches && window.caches.open(CACHE_NAME).then((cache) => {
            // eslint-disable-next-line promise/no-nesting
            cache.addAll(urls).catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
            });
            return null;
        });
    }

    static redirectMediaUrl(url?: string) {
        if (url && 'serviceWorkerAvailable' in window) {
            // eslint-disable-next-line no-restricted-globals
            return `${location.protocol}//${location.host}/media-stream/${encodeURIComponent(url)}`;
        }
        return url;
    }
}
